(function () {

  'use strict';

  angular.module('UserList')

    .constant('USER_FILTERS', [{
      name: 'Role',
      parameter: 'roles',
      type: 'checkbox',
      values: [
        {
          key: 'KIOSK_USER',
          value: 'KIOSK_USER',
          type: 'checkbox'
        },
        {
          key: 'GUEST_USER',
          value: 'Guest',
          type: 'checkbox'
        },
        {
          key: 'USER',
          value: 'USER',
          type: 'checkbox'
        },
        {
          key: 'SYSTEM_OBSERVER',
          value: 'SYSTEM_OBSERVER',
          type: 'checkbox'
        },
        {
          key: 'SYSTEM_MANAGER',
          value: 'SYSTEM_MANAGER',
          type: 'checkbox'
        },
        {
          key: 'SITE_MANAGER',
          value: 'SITE_MANAGER',
          type: 'checkbox'
        }
      ]
    }])

    .constant('SORT_USERS', {
      NAME: 'Name',
      EMAIL: 'Email'
    })

    .controller('UserListController', function (
      $rootScope, $scope, $filter, $timeout, URLS, $location, UserListService, $ngBootbox,
      URL_PARAMS, toastr, USER_FILTERS, UserListPaging, SORT_USERS, EventHandlerService,
      $routeParams, $window, currentTenant) {

      $scope.orderByText = 'Name';
      $scope.reverse = false;
      $scope.searchInputFieldHolderFocusKey = 'searchInputFieldHolderFocusKey';
      $scope.checkAllCheckboxes = false;
      $scope.selectedUsers = 0;
      $scope.urls = URLS;
      $scope.userContainer = null;
      $scope.userListPaging = new UserListPaging();
      $scope.requestType = 'GET';
      $scope.filtersList = null;

      $scope.searchInputPlaceholderText = 'SearchUserByNameAndEmail';
      $scope.noDataMessage = 'NoSearchResultUser';
      $scope.helpCaption = 'HelpUsersPage';
      $scope.windowWidth = $window.innerWidth;
      $scope.loadingPage = false;
      $scope.forceFilter = false;
      $scope.presetFilters = null;

      let initialListRequest = true;

      $scope.$watch(function () {
        return $rootScope.currentUser;
      }, function () {
        if ($rootScope.currentUser) {
          $scope.me = $rootScope.currentUser;
        }
      });

      (function () {
        EventHandlerService.deRegisterListeners();
        initFilters();
      })();

      function initFilters() {

        const filterPreset = $routeParams.filterPreset;
        if (filterPreset && filterPreset === 'GUEST_USER') {
          $scope.forceFilter = true;
          $scope.presetFilters = [{
            key: 'GUEST_USER',
            name: 'Guest',
            parameter: 'roles',
            type: 'checkbox',
            value: 'Guest',
            state: true
          }];
        }

        $scope.userListPaging.pagingCriteria.page = $routeParams.usersPage > 1 ? $routeParams.usersPage - 1 : 0;

        if (!currentTenant.info.cloudApiGuestUser) {
          $scope.forceFilter = false;
          $scope.presetFilters = null;
          USER_FILTERS[0].values.forEach(function (filter, index) {
            if (filter.key === 'GUEST_USER') {
              USER_FILTERS[0].values.splice(index, 1);
            }
          });
        }

        $scope.filtersList = USER_FILTERS;
      }

      function reportWindowSize() {
        $scope.windowWidth = $window.innerWidth;
        $scope.$apply();
      }

      $window.onresize = reportWindowSize;

      $scope.deleteUser = function (user) {
        if (user) {
          const name = (user.info._embedded.user.name) ? user.info._embedded.user.name : user.info._embedded.user.email;
          $ngBootbox.confirm($filter('stringular')($filter('translate')('DeleteUser'), name))
            .then(function () {
              UserListService.deleteUser(user)
                .then(function () {
                  toastr.success($filter('stringular')($filter('translate')('UserDeleted'), name));
                })
                .catch(function () {
                });
            })
            .catch(function () {
            });
        } else {
          throw new Error('$scope.deleteUser: user is missing');
        }
      };

      $scope.deleteSelectedUsers = function () {
        if ($scope.userContainer.list.length > 0) {
          const userList = $scope.userContainer.list.findAllElements({
            options: {
              isSelected: true
            }
          });
          if (userList.length) {
            const name = userList[0].info._embedded.user.name || userList[0].info._embedded.user.email;
            let message = '';
            if (userList.length < 2) {
              message = $filter('stringular')($filter('translate')('DeleteUser'), name);
            } else {
              message = $filter('stringular')($filter('translate')('DeleteUsers'), userList.length);
            }
            $ngBootbox.confirm(message)
              .then(function () {
                UserListService.deleteSelectedUsers(userList, function () {
                  let message = '';
                  if (userList.length < 2) {
                    message = $filter('stringular')($filter('translate')('UserDeleted'), name);
                  } else {
                    message = $filter('stringular')($filter('translate')('UsersDeleted'), userList.length);
                  }
                  toastr.success(message);
                });
              })
              .catch(function () {
              });
          } else {
            toastr.error($filter('translate')('SelectUserNone') + ', ' + $filter('translate')('SelectUser'));
          }
        } else {
          toastr.error($filter('translate')('SelectUserNone'));
        }
      };

      $scope.changeOrderByValue = function (textValue) {
        $scope.reverse = !$scope.reverse;
        $scope.userListPaging.pagingCriteria.direction = $scope.reverse ? 'DESC' : 'ASC';
        $scope.userListPaging.pagingCriteria.sort = textValue;
        $scope.orderByText = SORT_USERS[textValue];
        $scope.getUserListPaged();
      };

      $scope.editSelectedUsers = function (user) {
        if ($scope.userContainer.list.length) {
          const selectedItems = $scope.userContainer.list.findAllElements({
            options: {
              isSelected: true
            }
          });
          if (user || selectedItems.length) {
            if (user || selectedItems.length === 1) {
              if (!user) {
                user = selectedItems[0];
              }
              if (!user.info.expires) {
                const url = URLS.USER_PROPERTIES.replace(URL_PARAMS.USER_ID.LOCATION, user.customProperties.id);
                $location.path(url);
              } else {
                toastr.error($filter('translate')('NothingToModify'));
              }
            } else {
              $location.path(URLS.USER_PROPERTIES_MULTI);
            }
          } else {
            throw new Error('$scope.editSelectedUsers: selectedItems or user are missing');
          }
        }
      };

      $scope.selectAllItems = function () {
        angular.forEach($scope.userContainer.list, function (value) {
          value.options.isSelected = $scope.checkAllCheckboxes;
        });
      };

      $scope.getUserListPaged = function (skipResetScroll) {
        if (!skipResetScroll) {
          angular.element('.px-scrollbar-scroll').scrollTop(0);
        }
        EventHandlerService.queue.stopQueue();
        $scope.loadingPage = true;
        UserListService.getUserListPaged($scope.userListPaging)
          .then(function (userContainer) {
            $scope.loadingPage = false;
            if (initialListRequest || $scope.userListPaging.pagingCriteria.page === 0) {
              initialListRequest = false;
              $location.path($location.path(), false).search({ usersPage: parseInt($scope.userListPaging.pagingCriteria.page) + 1 }).replace();
            } else {
              $location.path($location.path(), false).search({ usersPage: parseInt($scope.userListPaging.pagingCriteria.page) + 1 });
            }
            $scope.userContainer = angular.copy(userContainer);
            if (EventHandlerService.getControllerScope() !== 'usersList') {
              EventHandlerService.setControllerScopeData('usersList', $scope.userContainer.list);
            } else {
              refreshEventHandler();
            }
          })
          .catch(function () {
            $scope.loadingPage = false;
          });
      };

      function refreshEventHandler() {
        EventHandlerService.refreshScopeData('usersList', $scope.userContainer.list)
          .then(function () {
            EventHandlerService.queue.setState('idle');
          })
          .catch(function () {
          });
      }

      $scope.getNextPage = function functionName() {
        if ($scope.userListPaging.pagingCriteria.page + 1 < $scope.userContainer.page.totalPages) {
          $scope.userListPaging.pagingCriteria.page++;
          $scope.getUserListPaged();
        }
      };

      $scope.getPreviousPage = function functionName() {
        if ($scope.userListPaging.pagingCriteria.page > 0) {
          $scope.userListPaging.pagingCriteria.page--;
          $scope.getUserListPaged();
        }
      };

      const deregisterUserListListener = $rootScope.$on('usersList', function (event, data) {
        switch (data.operation) {
          case 'refreshList':
            $scope.getUserListPaged(true);
            break;
          case 'replaceItem':
            break;
        }
      });

      $scope.$on('$destroy', function () {
        deregisterUserListListener();
      });

      $scope.$watch(function () {
        return $scope.userContainer;
      }, function () {
        if ($scope.userContainer) {
          $scope.selectedUsers = $scope.userContainer.list.findAllElements({
            options: {
              isSelected: true
            }
          }).length;
          if (!$scope.selectedUsers) {
            $scope.checkAllCheckboxes = false;
          } else {
            $scope.checkAllCheckboxes = ($scope.selectedUsers === $scope.userContainer.list.length);
          }
        }
      }, true);

      $scope.openListMenu = function (event, user) {
        const position = document.getElementById(event.target.id).getBoundingClientRect();
        $timeout(function () {
          $scope.closeListMenu();
          $scope.listMenuContext = user;
          $scope.listMeta = {
            position: { left: position.x, top: position.y },
            parentId: event.target.id,
            type: 'userList',
            scrollContainerId: 'UserScrollContainer'
          };
          $scope.$apply();
        });
      };

      $scope.closeListMenu = function (user, action) {
        $scope.listMenuContext = null;
        $scope.listMeta = null;
        switch (action) {
          case 'DELETE_USER':
            $scope.deleteUser(user);
            break;
        }
      };

    });
})();
